import React from 'react';
import { RadioIcon, TwitchIcon, YoutubeIcon, TwitterIcon, MessageSquareIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-studio-950 pt-16 pb-8 border-t border-white/5 relative z-10" data-id="element-21">
      <div className="max-w-7xl mx-auto px-6" data-id="element-22">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-23">
          <div className="col-span-1 md:col-span-2" data-id="element-24">
            <div className="flex items-center gap-2 mb-6" data-id="element-25">
              <RadioIcon className="w-6 h-6 text-stream-500" data-id="element-26" />
              <span className="font-mono font-bold text-xl tracking-tight text-white" data-id="element-27">
                ORION<span className="text-stream-500" data-id="element-28">ARENA</span>
              </span>
            </div>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-29">
              The premier growth and monetization consultancy for professional
              broadcasters and streaming talent.
            </p>
            <div className="text-sm text-gray-500 font-mono" data-id="element-30">
              <p data-id="element-31">HQ: Limassol, Cyprus</p>
              <p data-id="element-32">Global Remote Operations</p>
            </div>
          </div>

          <div data-id="element-33">
            <h4 className="text-white font-semibold mb-4" data-id="element-34">Navigation</h4>
            <ul className="space-y-3" data-id="element-35">
              <li data-id="element-36">
                <a href="#services" className="text-gray-400 hover:text-stream-400 transition-colors text-sm" data-id="element-37">
                  Services
                </a>
              </li>
              <li data-id="element-38">
                <a href="#pricing" className="text-gray-400 hover:text-stream-400 transition-colors text-sm" data-id="element-39">
                  Pricing
                </a>
              </li>
              <li data-id="element-40">
                <a href="#team" className="text-gray-400 hover:text-stream-400 transition-colors text-sm" data-id="element-41">
                  Team
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="text-gray-400 hover:text-stream-400 transition-colors text-sm" data-id="element-43">
                  Case Studies
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-44">
            <h4 className="text-white font-semibold mb-4" data-id="element-45">Connect</h4>
            <div className="flex gap-4" data-id="element-46">
              <a href="#" className="w-10 h-10 rounded-full bg-studio-800 flex items-center justify-center text-gray-400 hover:text-white hover:bg-stream-600 transition-all" data-id="element-47">
                <TwitchIcon className="w-5 h-5" data-id="element-48" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-studio-800 flex items-center justify-center text-gray-400 hover:text-white hover:bg-stream-600 transition-all" data-id="element-49">
                <YoutubeIcon className="w-5 h-5" data-id="element-50" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-studio-800 flex items-center justify-center text-gray-400 hover:text-white hover:bg-stream-600 transition-all" data-id="element-51">
                <TwitterIcon className="w-5 h-5" data-id="element-52" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-studio-800 flex items-center justify-center text-gray-400 hover:text-white hover:bg-stream-600 transition-all" data-id="element-53">
                <MessageSquareIcon className="w-5 h-5" data-id="element-54" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-55">
          <p className="text-gray-500 text-sm" data-id="element-56">
            © 2026 Orionarena. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-57">
            <a href="#" className="hover:text-white transition-colors" data-id="element-58">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-59">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}